(function () {
  'use strict';
  var key = 'stact-pending-lead-v1';
  var origin = 'https://vinrum-konfigurator-neu.brangstrupholding.chatgpt.site';
  function pending(type) {
    var data = {type: type, createdAt: Date.now()};
    try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (_) {}
  }
  function read() {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; }
  }
  function publish(type) {
    var shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
      shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error && window.Shopify.customerPrivacy) publish(type);
      });
      return;
    }
    if (!shopify || !shopify.customerPrivacy ||
        typeof shopify.customerPrivacy.analyticsProcessingAllowed !== 'function' ||
        !shopify.customerPrivacy.analyticsProcessingAllowed()) return;
    var data = {lead_type: type};
    if (shopify.analytics && typeof shopify.analytics.publish === 'function') {
      shopify.analytics.publish('stact:lead_submitted', data);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: 'stact_lead_submitted', lead_type: type});
  }
  function init() {
    var glass = document.getElementById('stact-glass-contact');
    if (glass) glass.addEventListener('submit', function (event) {
      if (!event.defaultPrevented && glass.checkValidity()) pending('glas');
    });
    var frame = document.getElementById('stact-vinrum');
    if (frame) window.addEventListener('message', function (event) {
      if (event.origin !== origin || event.source !== frame.contentWindow || !event.data ||
          event.data.type !== 'stact-vinrum-submit') return;
      var d = event.data;
      if (typeof d.customer === 'string' && d.customer.trim() && d.customer.length <= 100 &&
          typeof d.email === 'string' && d.email.length <= 160 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email) &&
          typeof d.phone === 'string' && d.phone.trim() && d.phone.length <= 30 &&
          typeof d.project === 'string' && d.project.length > 0 && d.project.length <= 6000) pending('vinrum');
    });
    var params = new URLSearchParams(window.location.search);
    var type = window.location.pathname === '/pages/vinkaelder' && params.get('vinrum_sendt') === '1' ? 'vinrum' :
      window.location.pathname === '/pages/glas-til-vinrum' && params.get('glas_sendt') === '1' ? 'glas' : null;
    var saved = read();
    if (type && saved && saved.type === type && Date.now() - saved.createdAt >= 0 &&
        Date.now() - saved.createdAt < 30 * 60 * 1000) {
      try { sessionStorage.removeItem(key); } catch (_) {}
      publish(type);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
